// extracted by mini-css-extract-plugin
module.exports = {"section":"SettingsSection_section__3hcbd","title":"SettingsSection_title__3dsNR","content":"SettingsSection_content__2qYkP"};